export default "/_next/static/chunks/fonts/proximanova-regular-webfont-00e7a1b0f0042e5eea6a2614bd16108b.woff2";